import { GET_ALL_POI } from '../constants/urls';
import zfetch, { METHOD_GET } from '../pages/common/utils/zfetch';

const getAllPOI = workspaceId => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId },
  };

  return zfetch(GET_ALL_POI, options).then(res => res.json());
};

export { getAllPOI };
